// extracted by mini-css-extract-plugin
module.exports = {"background":"background--3ogX3","leftNav":"leftNav--1GZF8","rightNav":"rightNav--Q0YSk","topNav":"topNav--2bfXI","username":"username--3YCGf"};